module.exports = __webpack_public_path__ + "img/domaine.c70f4453.png";